import {
    authenticatedApi,
    ApiError,
    API_BASE_URL
} from './apiUtils';

export const competencyTemplatesApi = {
  getAllTemplates: async () => {
    try {
      return await authenticatedApi.get(`${API_BASE_URL}/competency-templates`);
    } catch (error) {
      throw new ApiError('Failed to fetch competency templates', error.status || 500);
    }
  },

  getTemplatesByType: async (type) => {
    try {
      return await authenticatedApi.get(`${API_BASE_URL}/competency-templates/type/${type}`);
    } catch (error) {
      throw new ApiError(`Failed to fetch ${type} competency templates`, error.status || 500);
    }
  },

  createTemplate: async (templateData) => {
    try {
      return await authenticatedApi.post(`${API_BASE_URL}/competency-templates`, templateData);
    } catch (error) {
      if (error.status === 400) {
        throw new ApiError(error.data?.error || 'Invalid competency template data', 400);
      }
      throw new ApiError('Failed to create competency template', error.status || 500);
    }
  },

  updateTemplate: async (templateId, templateData) => {
    try {
      return await authenticatedApi.put(`${API_BASE_URL}/competency-templates/${templateId}`, templateData);
    } catch (error) {
      if (error.status === 400) {
        throw new ApiError(error.data?.error || 'Invalid competency template data', 400);
      }
      if (error.status === 404) {
        throw new ApiError('Competency template not found', 404);
      }
      throw new ApiError('Failed to update competency template', error.status || 500);
    }
  },

  deleteTemplate: async (templateId) => {
    try {
      return await authenticatedApi.delete(`${API_BASE_URL}/competency-templates/${templateId}`);
    } catch (error) {
      if (error.status === 404) {
        throw new ApiError('Competency template not found', 404);
      }
      throw new ApiError('Failed to delete competency template', error.status || 500);
    }
  },

  // Competency Levels endpoints
  getTemplateLevels: async (templateId) => {
    try {
      return await authenticatedApi.get(`${API_BASE_URL}/competency-templates/${templateId}/levels`);
    } catch (error) {
      if (error.status === 404) {
        throw new ApiError('Competency template not found', 404);
      }
      throw new ApiError('Failed to fetch competency levels', error.status || 500);
    }
  },

  createLevel: async (levelData) => {
    try {
      return await authenticatedApi.post(`${API_BASE_URL}/competency-levels`, levelData);
    } catch (error) {
      if (error.status === 400) {
        throw new ApiError(error.data?.error || 'Invalid competency level data', 400);
      }
      if (error.status === 404) {
        throw new ApiError('Competency template not found', 404);
      }
      throw new ApiError('Failed to create competency level', error.status || 500);
    }
  },

  updateLevel: async (levelId, levelData) => {
    try {
      return await authenticatedApi.put(`${API_BASE_URL}/competency-levels/${levelId}`, levelData);
    } catch (error) {
      if (error.status === 400) {
        throw new ApiError(error.data?.error || 'Invalid competency level data', 400);
      }
      if (error.status === 404) {
        throw new ApiError('Competency level not found', 404);
      }
      throw new ApiError('Failed to update competency level', error.status || 500);
    }
  },

  deleteLevel: async (levelId) => {
    try {
      return await authenticatedApi.delete(`${API_BASE_URL}/competency-levels/${levelId}`);
    } catch (error) {
      if (error.status === 404) {
        throw new ApiError('Competency level not found', 404);
      }
      throw new ApiError('Failed to delete competency level', error.status || 500);
    }
  }
};